import React from "react";
import styled from "styled-components";
import { CheckIcon } from "@akj-dev/design-system";

// quote
// signed
// unsigned
// approved
// cancelled
// complete
// rejected
// approval
// Resign
// re_sign_signed
// re_sign_approved
// re_sign_completed
// re_sign_rejected
// re_sign_unsigned
// re_sign_approval

const OrderStatusChip = ({ status }) => {
  switch (status) {
    case "quote":
      return (
        <Chip>
          <CheckIcon />
          Quote
        </Chip>
      );
    default:
      return <Chip>{status}</Chip>;
  }
};

const Chip = styled.div`
  vertical-align: middle;
`;

export default OrderStatusChip;
